import { all, takeEvery, call, put, select } from 'redux-saga/effects';
import {
  FETCH_ERROR,
  FETCH_REQUEST,
  FETCH_SUCCESS,
  MAYBE_FETCH_REQUEST,
} from './sharedActionTypes';
import { handleFetch } from './fetcher';

import { toast } from 'react-toastify';
import { selectRequestStatusByAction } from './reducers/fetcher';
import {
  FETCH_IF_NOT_FETCHED,
  FORCED_FETCH,
  STALE_WHILE_REVALIDATE,
} from './fetchModes';

function* fetchRequest(action) {
  // console.log('tomato', action);
  const { data: reqData, fetchType } = action;
  try {
    const { data: resData, message } = yield call(
      handleFetch,
      fetchType,
      reqData
    );
    yield put({
      type: FETCH_SUCCESS,
      fetchType,
      data: resData,
      reqData,
      success: message,
    });
  } catch (e) {
    console.error(e);
    yield put({
      type: FETCH_ERROR,
      fetchType,
      error: e.message,
      data: reqData,
      code: e.code,
      errorType: e.type,
    });
  }
}

function* maybeFetchRequest(action) {
  const requestState = yield select(selectRequestStatusByAction, action);
  // console.log('potato', action, JSON.stringify(requestState));
  if (requestState && requestState.loading) {
    // DON'T RE-FETCH IF ALREADY LOADING
    return;
  }
  if (requestState && requestState.loaded) {
    // DON'T RE-FETCH IF ALREADY LOADED
    switch (action.mode) {
      case FETCH_IF_NOT_FETCHED:
      default:
        return;
      case FORCED_FETCH:
      case STALE_WHILE_REVALIDATE:
    }
  }
  yield put({
    ...action,
    type: FETCH_REQUEST,
  });
}

function* watchFetchRequests() {
  yield takeEvery(FETCH_REQUEST, fetchRequest);
}

function* watchMaybeFetchRequests() {
  yield takeEvery(MAYBE_FETCH_REQUEST, maybeFetchRequest);
}

const fetchErrorToasts = ({ error }) => {
  toast.error(error);
};

function* fetchError(action) {
  yield call(fetchErrorToasts, action);
}

function* watchFetchErrors() {
  yield takeEvery(FETCH_ERROR, fetchError);
}

/*function* fetchSuccess(action) {
  yield call(fetchSuccessToasts, action);
}

function* watchFetchSuccesses() {
  yield takeEvery(FETCH_SUCCESS, fetchSuccess);
}*/

export default function* rootSaga() {
  try {
    yield all([
      watchMaybeFetchRequests(),
      watchFetchRequests(),
      watchFetchErrors() /*, watchFetchSuccesses()*/,
    ]);
  } catch (error) {
    console.error('Error at root saga:', error.message);
  }
}
